import CreateOrChangeTariffForm from './CreateOrChangeTariffForm';

export default CreateOrChangeTariffForm;
